// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__J_5ex","cover":"styles_cover__2pIuA","removeButton":"styles_removeButton__24Zex","play":"styles_play__2FrjO"};